var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoupeBlue = function SvgCoupeBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 28.73,
    viewBox: "0 0 78 28.73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(56.207 15.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M648.457,232.342a6.745,6.745,0,0,0,5.97-3.653,6.98,6.98,0,0,0,.794-3.113,6.766,6.766,0,1,0-13.122,2.233,6.606,6.606,0,0,0,.386.88A6.746,6.746,0,0,0,648.457,232.342Zm-3.749-9.024a4.375,4.375,0,1,1,7.51,4.491,4.375,4.375,0,1,1-7.51-4.491Z",
    transform: "translate(-641.691 -218.811)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M669.789,220.986a.441.441,0,0,1,0-.881h4.46a5.7,5.7,0,0,0-4.687-2.71l-20.548-.387a7.884,7.884,0,0,1-4.582-1.566l-5.353-3.978a23.839,23.839,0,0,0-27-.992l-6.845,4.345a2.156,2.156,0,0,1-1.111.335l-3.055.058-.129,0a3.779,3.779,0,0,0-3.8,3.562h2.214a.44.44,0,1,1,0,.88h-2.239v2.894h2.239a.44.44,0,1,1,0,.88h-2.224a7.841,7.841,0,0,0,.385,2.16h8.4a7.633,7.633,0,0,1,13.928,0h33.285a7.632,7.632,0,0,1,13.927,0h7.665a7.787,7.787,0,0,0,.4-2.454,5.746,5.746,0,0,0-.414-2.142Zm-50.224-11.363,1.057,5.756-3.532-.184a1.968,1.968,0,0,1-1.213-3.431A10.724,10.724,0,0,1,619.565,209.623ZM622,215.187l-1.076-5.862-.011-.067a10.224,10.224,0,0,1,1.219-.2l1.441-.121c.575-.048,1.15-.072,1.721-.072a20.463,20.463,0,0,1,12.623,4.373l3.776,2.969.048.166-.144.093-19.549-1.019Zm3.083,4.225h-2.28a.44.44,0,1,1,0-.88h2.28a.44.44,0,1,1,0,.88Z",
    transform: "translate(-597.114 -206.757)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(70.276 19.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M659.817,222.385h-6.968a7.624,7.624,0,0,1,.009,4.485A7.823,7.823,0,0,0,659.817,222.385Z",
    transform: "translate(-652.849 -222.385)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(23.064 19.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M615.406,222.385a7.631,7.631,0,0,1,.008,4.491H648a7.616,7.616,0,0,1,.006-4.491Z",
    transform: "translate(-615.406 -222.385)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(0.756 19.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M597.714,222.385a7.83,7.83,0,0,0,7.07,4.491h.623a7.643,7.643,0,0,1,.006-4.491Z",
    transform: "translate(-597.714 -222.385)",
    fill: "#06016c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(8.994 15.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M611.014,232.342a6.745,6.745,0,0,0,5.97-3.653,6.982,6.982,0,0,0,.794-3.113,6.743,6.743,0,0,0-12.722-3.138,6.573,6.573,0,0,0-.392.88,6.774,6.774,0,0,0,6.35,9.024Zm-3.75-9.024a4.349,4.349,0,0,1,7.5,0,4.278,4.278,0,0,1,.015,4.491,4.429,4.429,0,0,1-.667.88,4.382,4.382,0,0,1-6.192,0,4.431,4.431,0,0,1-.667-.88,4.275,4.275,0,0,1,.014-4.491Z",
    transform: "translate(-604.247 -218.811)",
    fill: "#06016c"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoupeBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coupeBlue.912713a2.svg";
export { ForwardRef as ReactComponent };